import { DormitoryServicePath, PRICES, ROOM_TYPES } from "utils/constants";
import permissions from "app/permissions";
import EditAccommodationPrice from "./Edit";

export const resources = {
  name: `${DormitoryServicePath}${ROOM_TYPES}/:typeId/${PRICES}/:id/edit`,
  title: "Редактиране на цена за настаняване",
  custom: <EditAccommodationPrice />,
  permission: permissions.canManageDormitoryAccommodationPrices,
};
